export { NguCarouselModule } from './src/ngu-carousel.module';
export { NguCarousel, NguCarouselStore } from './src/ngu-carousel/ngu-carousel.interface';
//# sourceMappingURL=index.js.map